<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Set Configuration</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog('No')"></button>
  <!-- <div class="modal-header-action">
    <button type="button" class="btn btn-primary btn-round btn-shadow" (click)="setConfigModal({});" title="Add"><i
        class="fa fa-plus"></i> Add</button>
  </div> -->
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
      <lib-vio-input [formsData]="configForm"></lib-vio-input>
    </div>
    <div class="modal-header-action">
      <button type="button" class="btn btn-primary btn-round btn-shadow" (click)="setConfigModal({});" title="Add"><i
          class="fa fa-plus"></i> Add</button>
    </div>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
      <vio-table *ngIf="showTable" [tableConfig]="tableConfig" [tableData]="tableData" [tableHeader]="tableHeader"
        (rowSelectionChange)="changeEvent($event)" (buttonClickEvent)="buttonClickEvent($event)"></vio-table>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success btn-round btn-shadow mx-1 mt-2" aria-label="Close"
    (click)="saveConfig('Yes')"><i class="fa fa-save"></i> Save</button>
  <button type="button" class="btn btn-secondary btn-round btn-shadow mx-1" aria-label="Close"
    (click)="closeDialog('No')"><i class="fa fa-times-circle"></i> Close</button>
</div>
